var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCricket(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#27A376",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2780_12439)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.9379 25.883H28.4036L26.3447 18.8242H13.6487L11.5898 25.883H17.0555V22.9419H22.9379V25.883Z",
    fill: "#27A376"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3906 29.9998H17.0573V27.0586H11.2485L10.3906 29.9998Z",
    fill: "#27A376"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1441 14.7059H22.9383V10H17.0559V14.7059H14.85L13.9922 17.6471H26.002L25.1441 14.7059ZM21.7618 14.7059H20.5853V11.1765H21.7618V14.7059ZM18.2324 11.1765H19.4089V14.7059H18.2324V11.1765Z",
    fill: "#27A376"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2344 24.1172H19.4108V29.9995H18.2344V24.1172Z",
    fill: "#27A376"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7502 27.0586H22.9414V29.9998H29.6081L28.7502 27.0586Z",
    fill: "#27A376"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5859 24.1172H21.7624V29.9995H20.5859V24.1172Z",
    fill: "#27A376"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2780_12439"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCricket);
export default __webpack_public_path__ + "static/media/cricket.181cdd67e60ea10952c81380d0fb6a34.svg";
export { ForwardRef as ReactComponent };